// src/components/SubstituteSessions.jsx
// 代講する授業（ほかの先生の授業）【2026-11-04】
//   GET /api/schedule/sessions/my-substitutes
//   先生のダッシュボードと授業管理（授業一覧）に出す。代講が無ければ何も出さない。
//   代講の先生にできるのは、代講する回の前日から N 日後まで、その回の出欠の確認・修正など（授業の設定は担当の先生だけ）。
//   開く先は /classes/:id/edit（代講する回だけが出る）。
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const auth = () => ({ Authorization: 'Bearer ' + localStorage.getItem('token') });
const DOW = ['日', '月', '火', '水', '木', '金', '土'];
function dayLabel(s) {
  const [y, m, d] = String(s).split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const diff = Math.round((dt - t) / 86400000);
  const rel = diff === 0 ? '今日' : diff === 1 ? '明日' : diff === -1 ? '昨日' : '';
  return `${m}/${d}（${DOW[dt.getDay()]}）${rel ? ' ' + rel : ''}`;
}

export default function SubstituteSessions({ title = '代講する授業' }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch('/api/schedule/sessions/my-substitutes', { headers: auth() })
      .then(r => r.json()).then(d => { if (alive) setData(d && d.success ? d : null); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, []);

  if (!data || !data.sessions || data.sessions.length === 0) return null;
  const days = data.editDays ?? 7;

  return (
    <div className="card" style={{ borderLeft: '4px solid #7c3aed' }}>
      <div className="card-header"><h2>{title}<small style={{ marginLeft: '0.5rem', color: '#6b7280', fontWeight: 400 }}>{data.sessions.length}回</small></h2></div>
      <p style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: 0 }}>
        ほかの先生の授業で、代講を頼まれている回です。回の日の前日から{days}日後まで、その回の受付・出欠の確認と修正ができます（授業の設定は担当の先生だけ）。
      </p>
      <div className="table-wrap">
        <table className="data-table">
          <thead><tr><th>日</th><th>時間</th><th>授業</th><th>担当の先生</th><th></th></tr></thead>
          <tbody>
            {data.sessions.map(s => (
              <tr key={s.sessionId}>
                <td style={{ whiteSpace: 'nowrap' }}>{dayLabel(s.sessionDate)}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{s.startTime ? `${s.startTime}${s.endTime ? '〜' + s.endTime : ''}` : '—'}{s.room ? <><br /><small style={{ color: '#6b7280' }}>{s.room}</small></> : null}</td>
                <td>{s.className}{s.reason ? <><br /><small style={{ color: '#6b7280' }}>{s.reason}</small></> : null}</td>
                <td>{s.teacherName ? `${s.teacherName} 先生` : '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {s.editable
                    ? <Link className="btn-secondary" to={`/classes/${s.classId}/edit`}>出欠の確認・修正</Link>
                    : <small style={{ color: '#9ca3af' }}>前日から開けます</small>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
